import { Stack, Text } from '@fluentui/react'
import { Doughnut } from 'react-chartjs-2'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import { FeedbackSummaryResponse } from '../../api/models'

ChartJS.register(ArcElement, Tooltip, Legend)

type FeedbackChartProps = {
  data: FeedbackSummaryResponse | null
}

const cardStyle = {
  root: {
    padding: '24px',
    backgroundColor: '#fff',
    borderRadius: 8,
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    minWidth: 300,
    flex: 1,
  },
}

const FeedbackChart = ({ data }: FeedbackChartProps) => {
  if (!data) return null

  const chartData = {
    labels: ['Positive', 'Negative'],
    datasets: [
      {
        data: [data.positive, data.negative],
        backgroundColor: ['#5B8A72', '#D4775B'],
        borderWidth: 1,
        borderColor: '#fff',
      },
    ],
  }

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom' as const,
      },
    },
  }

  return (
    <Stack styles={cardStyle} tokens={{ childrenGap: 12 }}>
      <Text variant="mediumPlus" styles={{ root: { fontWeight: 600, color: '#605e5c' } }}>
        Feedback Summary
      </Text>
      <Stack horizontal tokens={{ childrenGap: 16 }}>
        <Stack tokens={{ childrenGap: 4 }}>
          <Text variant="small" styles={{ root: { color: '#5B8A72' } }}>Positive</Text>
          <Text variant="large" styles={{ root: { fontWeight: 600 } }}>{data.positive}</Text>
        </Stack>
        <Stack tokens={{ childrenGap: 4 }}>
          <Text variant="small" styles={{ root: { color: '#D4775B' } }}>Negative</Text>
          <Text variant="large" styles={{ root: { fontWeight: 600 } }}>{data.negative}</Text>
        </Stack>
      </Stack>
      {data.total_with_feedback > 0 && (
        <div style={{ height: 220 }}>
          <Doughnut data={chartData} options={options} />
        </div>
      )}
      {data.total_with_feedback === 0 && (
        <Text styles={{ root: { color: '#a19f9d', textAlign: 'center', padding: 40 } }}>
          No feedback data available for this period.
        </Text>
      )}
    </Stack>
  )
}

export default FeedbackChart
